// Load all necessary files for all homepages
require('./home-ALL');

/*****************************************************************************************************
 * Load Libraries
 */

require('select2');
require('@RESOURCES/js/select2-factory');
/*****************************************************************************************************
 * Load All Internal Components
 */

// commenting as it's locally loaded now
// Vue.component(
//     'age-checker-gb',
//     require('@RESOURCES/js/components/age-checker/AgeCheckerGB.vue').default
// );

Vue.component('loading-spinner', require('@RESOURCES/js/components/LoadingSpinner.vue').default);
Vue.component('popup-offer', require('@RESOURCES/js/components/operator_list/PopupOffer.vue').default);
Vue.component('operator-list-tab', require('@RESOURCES/js/components/operator_list/OperatorListTab.vue').default);
Vue.component('show-more-show-less-button', require('@RESOURCES/js/components/operator_list/ShowMoreShowLessButton.vue').default);

// /*****************************************************************************************************
// * CollapsibleButton
// */
import CollapsibleButton from '@RESOURCES/js/services/collapsible/CollapsibleButton';
import Collapsible from '@RESOURCES/js/services/collapsible/Collapsible';

global.CollapsibleButton = CollapsibleButton;

global.Collapsible = Collapsible;
